import { cn } from '@/lib/utils';

/**
 * CompletionIndicator displays a completion indicator for a given rate in percentage. 0 - 100.
 * Brand orange while work is left, green only once it is all done.
 */
export const CompletionIndicator = ({
  className,
  rate,
}: {
  className?: string;
  rate: number;
}) => (
  <div
    className={cn(
      'h-1.5 w-full overflow-hidden rounded-full',
      rate >= 100 ? 'bg-success/15' : 'bg-brand/15',
      className
    )}>
    <div
      className={cn(
        'h-full rounded-full transition-all duration-300',
        rate >= 100 ? 'bg-success' : 'bg-brand'
      )}
      style={{ width: `${rate}%` }}
    />
  </div>
);
